import { render, staticRenderFns } from "./RetrievalTable.vue?vue&type=template&id=85149d62&scoped=true&"
import script from "./RetrievalTable.vue?vue&type=script&lang=js&"
export * from "./RetrievalTable.vue?vue&type=script&lang=js&"
import style0 from "./RetrievalTable.vue?vue&type=style&index=0&id=85149d62&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85149d62",
  null
  
)

export default component.exports